import { getOriginalUrl } from '@/helpers/documentHelpers';
import { trimFileNames } from '@/helpers/trimFileNames';
import { Box } from '@palmetto/palmetto-components';

import { DocumentFile } from 'types';

export function FileItem({ file, className }: { file: DocumentFile; className?: string }) {
  const originalUrl = getOriginalUrl(file?.viewUrls);
  const truncateFileName = trimFileNames(file.originalName);

  return (
    <div className={className}>
      <Box
        width={{
          base: 'xl',
          tablet: 'xl',
          desktop: 'xl',
          hd: '3xl',
        }}
      >
        <a href={originalUrl} target="_blank" rel="noopener noreferrer" title={file.originalName}>
          {truncateFileName}
        </a>
      </Box>
    </div>
  );
}
